import classNames from "classnames";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "src/store";
import { formatTimeFromUnit } from "src/utility";

const CountdownTimerSlider: FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();
  const maxTimer = useSelector((state: RootState) => state.timer.maxTime);
  const startedAt = useSelector((state: RootState) => state.timer.startedAt);
  const isRunning = useSelector((state: RootState) => state.timer.isRunning);

  const getRemaining = () => (startedAt ? Math.max(0, maxTimer - (Date.now() - startedAt)) : maxTimer);

  const [remaining, setRemaining] = useState(getRemaining);
  const progress = (remaining * 100) / maxTimer;
  const color =
    progress > 10
      ? "var(--color-font-success)"
      : progress > 5
        ? "var(--color-font-warning)"
        : "var(--color-font-danger)";

  useEffect(() => {
    if (!isRunning) return;

    setRemaining(getRemaining());

    const interval = setInterval(() => {
      const next = getRemaining();
      setRemaining(next);
      if (next <= 0) clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, [isRunning, startedAt, maxTimer]);

  if (!isRunning) return null;

  return (
    <div className={classNames("flex w-full flex-col flex-wrap items-center justify-center gap-1 rounded-b-md bg-background-warning px-5 py-1 text-font-default md:flex-row", className)}>
      <div className="whitespace-pre-wrap text-sm">{t("Common.countdown.completeBookingWarning")}</div>
      <div className="font-inter font-medium" style={{ color }}>
        {formatTimeFromUnit(remaining, "ms")}
      </div>
    </div>
  );
};

export default CountdownTimerSlider;
